/*
window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');
require('daemonite-material');
*/
import 'expose-loader?Popper!popper.js';
import 'script-loader!bootstrap';
import 'script-loader!daemonite-material';


// Config
import 'script-loader!js-cookie';
import '../ext/config.js';

// Styles
import './app.scss';

// General
import './general.js';

//Tracking
import './tracking.js';

// Form Control
// import './form.js';

// Floatbar, menu
import './floatbar.js';

// Modal
import './popup.js';

// Product
import './product.js';

// Article
import './article.js';

// About
import './about.js';

// // About
// import './cart.js';


// WEBPACK FOOTER //
// ./src/app.js